"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListaDeSelecaoVertical = void 0;
var estiloListaDeSelecao = require("./lista-de-selecao-vertical.module.scss");
var react_1 = __importStar(require("react"));
var TextAreaLista_1 = require("../../Inputs/TextAreaLista/TextAreaLista");
var Botao_1 = require("../../Botao/Botao");
var Cores_1 = require("../../Cores/Cores");
var Icone_1 = require("../../Icone/Icone");
var Paginacao_1 = require("../../Paginacao/Paginacao");
;
var ListaDeSelecaoVertical = function (_a) {
    var _b;
    var paginas = _a.paginas, setPaginas = _a.setPaginas, arraySelecionados = _a.arraySelecionados, _c = _a.paginacao, _d = _c.paginaAtual, paginaAtual = _d === void 0 ? 1 : _d, _e = _c.itensPorPagina, itensPorPagina = _e === void 0 ? 10 : _e, _f = _c.quantidadePaginas, quantidadePaginas = _f === void 0 ? 1 : _f, _g = _c.quantidadeTotal, quantidadeTotal = _g === void 0 ? 0 : _g, _h = _a.config, _j = _h.regraEstado, regraEstado = _j === void 0 ? function () { return false; } : _j, _k = _h.selecaoExcludente, selecaoExcludente = _k === void 0 ? true : _k, _l = _h.listasOrdenadas, listasOrdenadas = _l === void 0 ? true : _l, _m = _h.regraTitulo, regraTitulo = _m === void 0 ? function (item) { return JSON.stringify(item); } : _m, tituloSelecao = _h.tituloSelecao, tituloSelecionados = _h.tituloSelecionados, styleSelecao = _h.styleSelecao, styleSelecionados = _h.styleSelecionados, onClickSelecao = _a.onClickSelecao, onClickSelecionados = _a.onClickSelecionados, onChange = _a.onChange, onChangeSelecao = _a.onChangeSelecao, onChagePaginaSelecionada = _a.onChagePaginaSelecionada;
    var arraySelecionadosConvertido = converterParaListaDeSelecaoInput(arraySelecionados, regraTitulo, regraEstado);
    var _o = (0, react_1.useState)(arraySelecionadosConvertido !== null && arraySelecionadosConvertido !== void 0 ? arraySelecionadosConvertido : []), listaDeSelecionados = _o[0], setListaDeSelecionados = _o[1];
    var _p = (0, react_1.useState)({
        paginaAtual: paginaAtual,
        itensPorPagina: itensPorPagina,
        quantidadePaginas: quantidadePaginas,
        quantidadeTotal: quantidadeTotal,
    }), dadosPaginacao = _p[0], setDadosPaginacao = _p[1];
    // const cachePaginas = useRef<Map<number, ListaDeSelecaoInput<T>[]>>(new Map());
    var inicializarCachePaginas = function () {
        var novoCachePaginas = new Map();
        paginas.forEach(function (listaT, numeroPagina) {
            var listaDeSelecaoInput = converterParaListaDeSelecaoInput(listaT, regraTitulo, regraEstado, numeroPagina);
            novoCachePaginas.set(numeroPagina, listaDeSelecaoInput);
        });
        return novoCachePaginas;
    };
    var _q = (0, react_1.useState)(inicializarCachePaginas()), cachePaginas = _q[0], setCachePaginas = _q[1];
    var mudarPagina = function (novaPagina) {
        setDadosPaginacao(function (prev) { return (__assign(__assign({}, prev), { paginaAtual: novaPagina })); });
        onChagePaginaSelecionada(novaPagina);
    };
    function converterParaListaDeSelecaoInput(lista, regraTitulo, regraEstado, paginaOrigem) {
        if (!lista)
            return [];
        return lista.map(function (objeto) { return ({
            objeto: objeto,
            titulo: regraTitulo(objeto),
            estado: regraEstado ? regraEstado(objeto) : false,
            paginaOrigem: paginaOrigem,
        }); });
    }
    var adicionarTodos = function () {
        var _a;
        var itensPaginaAtual = (_a = cachePaginas.get(dadosPaginacao.paginaAtual)) !== null && _a !== void 0 ? _a : [];
        if (selecaoExcludente) {
            var novoCachePaginas = new Map(cachePaginas);
            novoCachePaginas.set(dadosPaginacao.paginaAtual, []);
            setCachePaginas(novoCachePaginas);
            var novasPaginas = new Map(paginas);
            novasPaginas.set(dadosPaginacao.paginaAtual, []);
            setPaginas(novasPaginas);
            listasOrdenadas ?
                setListaDeSelecionados(function (prevLista) { return __spreadArray(__spreadArray([], prevLista, true), itensPaginaAtual, true).sort(function (a, b) { return a.titulo.localeCompare(b.titulo); }); })
                : setListaDeSelecionados(function (prevLista) { return __spreadArray(__spreadArray([], prevLista, true), itensPaginaAtual, true); });
            onChangeSelecao && onChangeSelecao([]);
        }
        else {
            listasOrdenadas ?
                setListaDeSelecionados(function (prevLista) { return __spreadArray(__spreadArray([], prevLista, true), itensPaginaAtual, true).sort(function (a, b) { return a.titulo.localeCompare(b.titulo); }); })
                : setListaDeSelecionados(function (prevLista) { return __spreadArray(__spreadArray([], prevLista, true), itensPaginaAtual, true); });
        }
        onChange && onChange(__spreadArray(__spreadArray([], listaDeSelecionados.map(function (item) { return item.objeto; }), true), itensPaginaAtual.map(function (item) { return item.objeto; }), true));
    };
    var adicionarItens = function () {
        var _a;
        var itensPaginaAtual = (_a = cachePaginas.get(dadosPaginacao.paginaAtual)) !== null && _a !== void 0 ? _a : [];
        var itensSelecionados = itensPaginaAtual.filter(function (item) { return item.estado; }).map(function (item) { return (__assign(__assign({}, item), { estado: false })); });
        listasOrdenadas ?
            setListaDeSelecionados(function (prevLista) { return __spreadArray(__spreadArray([], prevLista, true), itensSelecionados, true).sort(function (a, b) { return a.titulo.localeCompare(b.titulo); }); })
            : setListaDeSelecionados(function (prevLista) { return __spreadArray(__spreadArray([], prevLista, true), itensSelecionados, true); });
        if (selecaoExcludente) {
            var novosDadosPagina = itensPaginaAtual.filter(function (item) { return !item.estado; });
            var novoCachePaginas = new Map(cachePaginas);
            novoCachePaginas.set(dadosPaginacao.paginaAtual, novosDadosPagina);
            setCachePaginas(novoCachePaginas);
            var listaObjetos = novosDadosPagina.map(function (item) { return item.objeto; });
            var novasPaginas = new Map(paginas);
            novasPaginas.set(dadosPaginacao.paginaAtual, listaObjetos);
            setPaginas(novasPaginas);
        }
        onChange && onChange(__spreadArray(__spreadArray([], listaDeSelecionados.map(function (item) { return item.objeto; }), true), itensSelecionados.map(function (item) { return item.objeto; }), true));
    };
    var removerItens = function () {
        var _a;
        var itensSelecionados = listaDeSelecionados.filter(function (item) { return item.estado; }).map(function (item) { return (__assign(__assign({}, item), { estado: false })); });
        var listaDeSelecionadosAtualizada = (_a = listaDeSelecionados.filter(function (item) { return !item.estado; }).map(function (item) { return item.objeto; })) !== null && _a !== void 0 ? _a : [];
        if (selecaoExcludente) {
            itensSelecionados.forEach(function (item) {
                var _a;
                var paginaOrigem = (_a = item.paginaOrigem) !== null && _a !== void 0 ? _a : 1;
                var listaPagina = cachePaginas.get(paginaOrigem) || [];
                listaPagina.push(item);
                var novasPaginas = new Map(paginas);
                novasPaginas.set(paginaOrigem, listaPagina.map(function (item) { return item.objeto; }));
                setPaginas(novasPaginas);
                var novoCachePaginas = new Map(cachePaginas);
                novoCachePaginas.set(paginaOrigem, listaPagina);
                setCachePaginas(novoCachePaginas);
            });
        }
        onChange && onChange(listaDeSelecionadosAtualizada);
    };
    var removerTodos = function () {
        var _a;
        var itensSelecionados = listaDeSelecionados;
        setListaDeSelecionados([]);
        if (selecaoExcludente) {
            itensSelecionados.forEach(function (item) {
                var _a;
                var paginaOrigem = (_a = item.paginaOrigem) !== null && _a !== void 0 ? _a : 1;
                var listaPagina = cachePaginas.get(paginaOrigem) || [];
                listaPagina.push(item);
                var novoCachePaginas = new Map(cachePaginas);
                novoCachePaginas.set(paginaOrigem, listaPagina);
                setCachePaginas(novoCachePaginas);
                var novasPaginas = new Map(paginas);
                novasPaginas.set(paginaOrigem, listaPagina.map(function (item) { return item.objeto; }));
                setPaginas(novasPaginas);
            });
        }
        onChangeSelecao && onChangeSelecao(((_a = cachePaginas.get(dadosPaginacao.paginaAtual)) !== null && _a !== void 0 ? _a : []).map(function (item) { return item.objeto; }));
        onChange && onChange([]);
    };
    var handleClick = function (item, lista) {
        var _a;
        if (lista === "selecao") {
            var itensSelecionados = ((_a = cachePaginas.get(dadosPaginacao.paginaAtual)) !== null && _a !== void 0 ? _a : []).map(function (i) { return i === item ? __assign(__assign({}, i), { estado: !i.estado }) : i; });
            var novoCachePaginas = new Map(cachePaginas);
            novoCachePaginas.set(dadosPaginacao.paginaAtual, itensSelecionados);
            setCachePaginas(novoCachePaginas);
            onClickSelecao && onClickSelecao(itensSelecionados, dadosPaginacao.paginaAtual);
        }
        else {
            var novaListaDeSelecao = listaDeSelecionados.map(function (i) {
                return i === item ? __assign(__assign({}, i), { estado: !i.estado }) : i;
            });
            setListaDeSelecionados(novaListaDeSelecao);
            onClickSelecionados && onClickSelecionados(novaListaDeSelecao);
        }
    };
    var renderBotaoMenor = function (icon, onClick) {
        return (react_1.default.createElement("li", null,
            react_1.default.createElement(Botao_1.Botao, { tamanho: "small", exibirBotaoArrendondado: true, tipo: "tipoIconRound", estilo: "outlined", onClick: onClick },
                react_1.default.createElement(Icone_1.Icone, { nome: icon, cor: Cores_1.Cores.CoresIdentidadeMU.azulMu, largura: "1.5rem", altura: "1.5rem" }))));
    };
    var renderBotaoMaior = function (icon, onClick) {
        return (react_1.default.createElement("li", null,
            react_1.default.createElement(Botao_1.Botao, { exibirBotaoArrendondado: true, tipo: "tipoIconRound", tamanho: "large", onClick: onClick },
                react_1.default.createElement(Icone_1.Icone, { nome: icon, cor: Cores_1.Cores.CoresIdentidadeMU.brancoMu, largura: "2rem", altura: "2rem" }))));
    };
    var Controles = (react_1.default.createElement("ul", { className: estiloListaDeSelecao.controles },
        renderBotaoMenor("keyboard_double_arrow_down", adicionarTodos),
        renderBotaoMaior("arrow_downward", adicionarItens),
        renderBotaoMaior("arrow_upward", removerItens),
        renderBotaoMenor("keyboard_double_arrow_up", removerTodos)));
    (0, react_1.useEffect)(function () {
        setDadosPaginacao({
            paginaAtual: paginaAtual,
            itensPorPagina: itensPorPagina,
            quantidadePaginas: quantidadePaginas,
            quantidadeTotal: quantidadeTotal,
        });
    }, [paginas]);
    (0, react_1.useEffect)(function () {
        if (paginas && (paginas.size === 0 || cachePaginas.get(paginaAtual) === undefined)) {
            var novoCachePaginas = inicializarCachePaginas();
            setCachePaginas(novoCachePaginas);
        }
    }, [paginas, dadosPaginacao]);
    (0, react_1.useEffect)(function () {
        var _a;
        setListaDeSelecionados((_a = converterParaListaDeSelecaoInput(arraySelecionados, regraTitulo, regraEstado)) !== null && _a !== void 0 ? _a : []);
    }, [arraySelecionados]);
    return (react_1.default.createElement("div", { className: estiloListaDeSelecao.container },
        react_1.default.createElement("div", { key: 0, className: estiloListaDeSelecao.listaEsquerda },
            react_1.default.createElement(TextAreaLista_1.TextAreaLista, { id: "listaDeSelecao", titulo: tituloSelecao !== null && tituloSelecao !== void 0 ? tituloSelecao : "Seleção :", opcoes: (_b = cachePaginas.get(dadosPaginacao.paginaAtual)) !== null && _b !== void 0 ? _b : [], style: styleSelecao !== null && styleSelecao !== void 0 ? styleSelecao : {
                    minWidth: '10rem',
                    width: '50rem',
                    maxWidth: '50rem',
                    minHeight: '18rem',
                    maxHeight: '18rem',
                }, onClickItem: function (item) {
                    return handleClick(item, "selecao");
                } })),
        react_1.default.createElement("div", { style: {} },
            react_1.default.createElement(Paginacao_1.Paginacao, { totalItens: dadosPaginacao.quantidadeTotal, itensPorPagina: dadosPaginacao.itensPorPagina, paginaAtual: dadosPaginacao.paginaAtual, onItensPorPaginaChange: function (itensPorPagina) { }, onPageChange: mudarPagina, config: { permitirSelecaoItensPorPagina: false } })),
        react_1.default.createElement("div", { className: estiloListaDeSelecao.controles }, Controles),
        react_1.default.createElement("div", { className: estiloListaDeSelecao.listaDireita },
            react_1.default.createElement(TextAreaLista_1.TextAreaLista, { id: "listaDeSelecionados", titulo: tituloSelecionados !== null && tituloSelecionados !== void 0 ? tituloSelecionados : "Selecionados :", opcoes: listaDeSelecionados, style: styleSelecionados !== null && styleSelecionados !== void 0 ? styleSelecionados : {
                    minWidth: '10rem',
                    width: '50rem',
                    maxWidth: '50rem',
                    minHeight: '18rem',
                    maxHeight: '18rem',
                }, onClickItem: function (item) {
                    return handleClick(item, "selecionados");
                } }))));
};
exports.ListaDeSelecaoVertical = ListaDeSelecaoVertical;
